import { OrganisationDataProps } from "@models/components/organisation.model";
import { CaseReducer, createSlice, PayloadAction } from "@reduxjs/toolkit";

type initialType = {
  city: string;
  club: string;
  country: string;
  filteredOrganisationData: OrganisationDataProps[];
  isCity: boolean;
  isSearch: boolean;
};

const initialState: initialType = {
  city: "",
  club: "",
  country: "",
  filteredOrganisationData: [],
  isCity: true,
  isSearch: false,
};

type dashboardSliceReducer<Payload> = CaseReducer<
  initialType,
  PayloadAction<Payload>
>;

const setLocation: dashboardSliceReducer<{
  city: string;
  club: string;
  country: string;
  isCity: boolean;
  isSearch: boolean;
}> = (state, action) => {
  state.city = action.payload.city;
  state.country = action.payload.country;
  state.club = action.payload.club;
  state.isSearch = action.payload.isSearch;
  state.isCity = action.payload.isCity;
};

const setFilteredOrganisationData: dashboardSliceReducer<{
  filteredOrganisationData: OrganisationDataProps[];
}> = (state, action) => {
  state.filteredOrganisationData = action.payload.filteredOrganisationData;
};

export const dashboardSlice = createSlice({
  initialState,
  name: "dashboard",
  reducers: {
    setFilteredOrganisationData,
    setLocation,
  },
});

export default dashboardSlice;
